export const OPEN = "widget.open";
export const CLOSE = "widget.close";
export const SET_PAYLOAD = "widget.setPayload";
export const SET_ERROR = "widget.setError";
export const CLEAR = "widget.clear";
export const SET_PAYLOAD_COMPLETED = "widget.setPayloadCompleted";
